import React from "react";
import { CollectionInfo } from "../../models/system";

export class Collection extends React.Component<{ collectionInfos: CollectionInfo[] }>{
    state = { start: 0, end: 3 };
    handlePrev: () => void = () => {
        if (this.state.start > 0)
            this.setState({ start: this.state.start - 1, end: this.state.end - 1 });
    }
    handleNext: () => void = () => {
        if (this.state.end < this.props.collectionInfos.length)
            this.setState({ start: this.state.start + 1, end: this.state.end + 1 });
    }
    render(): React.ReactNode {
        return (
            <>

                <div className="container">
                    <div className="items">

                        {
                            this.props.collectionInfos?.slice(this.state.start, this.state.end).map(o =>
                                <div><img src={o.pic} alt={o.title}></img></div>)
                        }


                    </div>

                </div>
            </>
        );
    }

}